import css from '../ProgressBar/ProgressBar.css';
import React from 'react';

// export default function ProgressBar() {
//     return (
//         <div> 
//             Hello
//         </div>
//     )
// }

const ProgressBar = ({bgcolor,progress,height}) => {
     
    const Parentdiv = {
        height: height,
        width: '100%',
        backgroundColor: '#C4C4C4',
        borderRadius: 40,
        margin: 0
      }
      
      const Childdiv = {
        height: '100%',
        width: `${progress}%`,
        backgroundColor: bgcolor,
        borderRadius:40,
        textAlign: 'right'
      }
              
    return (
    <div className={css.Bar}>
    <div style={Parentdiv}>
      <div style={Childdiv}>
      </div>
    </div>
    </div>
    )
}
  
export default ProgressBar;
